// from backend-api/authtools/constants.py
export enum PermissionName {
  AbilityToPrelim = 'ABILITY_TO_PRELIM',
  AbilityToSign = 'ABILITY_TO_SIGN',
  AccessAdminPanel = 'ACCESS_ADMIN_PANEL',
  AccessReporterModule = 'ACCESS_REPORTER_MODULE',
  AccessViewerModule = 'ACCESS_VIEWER_MODULE',
  AccessWorklistModule = 'ACCESS_WORKLIST_MODULE',
  AdminManageSystemSettings = 'ADMIN_MANAGE_SYSTEM_SETTINGS',
  AllowBypassSignCountdown = 'ALLOW_BYPASS_SIGN_COUNTDOWN',
  AllowBypassPrelimCountdown = 'ALLOW_BYPASS_PRELIM_COUNTDOWN',
  AllowMarkAsDiscrepant = 'ALLOW_MARK_AS_DISCREPANT',
  ArchiveReadAccess = 'ARCHIVE_READ_ACCESS',
  ArchiveReadWriteAccess = 'ARCHIVE_READWRITE_ACCESS',
  AuthorTemplatesOrMacros = 'AUTHOR_TEMPLATES_MACROS',
  ClaimExam = 'CLAIM_EXAM',
  CustomWorklistsRead = 'WORKLIST_VIEW_READ',
  CustomWorklistsWrite = 'WORKLIST_VIEW_WRITE',
  PrivateWorklistWrite = 'PRIVATE_WORKLIST_WRITE',
  ExamCommentReadWriteAccess = 'EXAM_COMMENT_READWRITE_ACCESS',
  ResendReport = 'RESEND_REPORT',
  ManageSystemSettings = 'MANAGE_SYSTEM_SETTINGS',
  WorklistCaseAccess = 'WORKLIST_CASE_ACCESS',
  WorklistCaseAssign = 'WORKLIST_CASE_ASSIGN',
  WorklistQualityControlWorkflow = 'WORKLIST_QUALITY_CONTROL_WORKFLOW',
  WorklistCriticalWorkflow = 'WORKLIST_CRITICAL_WORKFLOW',
}
